var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "svgElement", staticClass: "connections-container" },
    [
      _c(
        "svg",
        {
          staticClass: "svg-container",
          attrs: { width: _vm.svgWidth + "px", height: _vm.svgHeight + "px" }
        },
        _vm._l(_vm.preparedConnections, function(obj, connectionIndex) {
          return _c("path", {
            key: "connection" + connectionIndex,
            staticClass: "connection_line",
            class: obj.connection.mode.toLowerCase(),
            attrs: {
              d: obj.connection.line,
              "stroke-dasharray": obj.connection.mode === "PASSING" ? "5 3" : ""
            }
          })
        }),
        0
      ),
      _vm._v(" "),
      _vm._l(_vm.cleanDuplicatedSplitter(_vm.preparedConnections), function(
        obj,
        connectionIndex
      ) {
        return obj.hasSplitter
          ? _c(
              "div",
              {
                key: connectionIndex,
                staticClass: "img-container",
                style: {
                  top: obj.splitterPosition.height + "px",
                  left: obj.splitterPosition.width + "px"
                },
                on: {
                  click: function($event) {
                    return _vm.selectSplitter(obj.splitter)
                  },
                  contextmenu: function($event) {
                    return _vm.openConnectionPointMenu($event, obj)
                  }
                }
              },
              [
                _c(
                  "v-tooltip",
                  {
                    attrs: { top: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "p",
                                _vm._g(
                                  _vm._b(
                                    { staticClass: "text-ellipsis" },
                                    "p",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(obj.splitter.sp_label) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm._v(" "),
                    _c("span", { style: { fontSize: "10px" } }, [
                      _vm._v(_vm._s(obj.splitter.sp_label))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("img", {
                  class: {
                    "splitter-opacity": _vm.isSplitterSelected(
                      obj.splitter.sp_id
                    )
                  },
                  attrs: { src: require("@/assets/splitter-1.png") }
                })
              ],
              1
            )
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d899e394", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d899e394","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splicing/Connections.vue
// module id = null
// module chunks = 